import { ReactNode } from 'react'
import styled from '@emotion/styled'
import { DashboardLoadStatus, DashboardSelection, isDashboardSelectionMatch, StatusedAppointment, statusedWorkItemKey } from "@fusion-advantage/formlib"
import { V2L1DashboardListHeader, V2L1DashboardListHeaderTitle } from './V2L1DashboardList'
import { V2L1DashboardListEmptyPlaceholder } from './V2L1DashboardListEmptyPlaceholder'
import { V2L2ApptListTimeline } from './V2L2ApptListTimeline'
import { V2L2ApptListItem } from './V2L2ApptListItem'
import { V2L2DashboardListStatusedContent } from './V2L2DashboardListStatusContent'

const V2L3ApptListRoot = styled.div(({theme}) => ({
	display: 'grid',
	gridTemplateRows: 'max-content max-content 1fr',
	border: `1px solid ${theme.colors.lines}`,
	borderRadius: theme.borderRadius,
	overflow: 'hidden',
}))

interface V2L3ApptListProps {
	status: DashboardLoadStatus
	displayDate: string
	displayAppts: StatusedAppointment[]
	allApptsCount: number
	navBar: ReactNode
	selection: DashboardSelection
	onItemClick: (item: StatusedAppointment) => void
}

export const V2L3ApptList = ({
	status,
	displayDate,
	displayAppts,
	allApptsCount,
	navBar,
	selection,
	onItemClick,
}: V2L3ApptListProps) => {
	return (
		<V2L3ApptListRoot>
			<V2L1DashboardListHeader>
				<V2L1DashboardListHeaderTitle>
					APPOINTMENTS ({
						displayAppts.length !== allApptsCount ?
						`${displayAppts.length} of ${allApptsCount} shown` : `${allApptsCount}`
					})
				</V2L1DashboardListHeaderTitle>
			</V2L1DashboardListHeader>
			{navBar}
			<V2L2DashboardListStatusedContent status={status}>
				{allApptsCount > 0 ? (
					<V2L2ApptListTimeline>
						{displayAppts.map((statusedItem) => (
							<V2L2ApptListItem
								key={statusedItem.item.ServiceAppointmentID}
								statusedItem={statusedItem}
								active={isDashboardSelectionMatch(statusedWorkItemKey(statusedItem), selection)}
								listDisplayDate={displayDate}
								onClick={() => onItemClick(statusedItem)}
							/>
						))}
					</V2L2ApptListTimeline>
				) : (
					<V2L1DashboardListEmptyPlaceholder
						title="0 Appointments"
						subtitle="Tap above to refresh"
					/>
				)}
			</V2L2DashboardListStatusedContent>
		</V2L3ApptListRoot>
	)
}
